<template>
<div>
    <base-header v-once pageName="도구검사 추천 이벤트" :prevBtnShow="true" history="main"></base-header>
    
    <section id="wrap">
        <div class="notice-Detail qr">
            <div>
                <p>오직 3차월까지만 누리는 특별한 찬스!</p>
            </div>
            <article>
                <img src="../../assets/images/event_2605.png">
            </article>
            <button type="button" class="reg" @click="copyUrl">추천 URL 복사하기</button>
            <button type="button" @click="goKss">내 추천 신청 현황 바로가기</button>
        </div>
    </section>
</div>
</template>

<script>
export default {
  data() {
      return{
        userId: "" // 사번
      };
  },
  mounted: function() {
    var that = this;
    this.$api.myCstmr.base()
      .then(function(res) {
        that.userId = res.loginUserid; 
      })
      .catch(function(error) {
        console.error('사용자 정보 로드 실패', error);
      });
  },

  methods: {
      // 💡 클립보드 복사 함수 추가
      copyUrl: function() {
      // 3. 버튼 클릭 시점에는 통신 없이 바로 복사만 실행!
      if (!this.userId) {
        alert('사용자 정보를 불러오는 중입니다. 잠시 후 다시 시도해 주세요.');
        return;
      }

      var url = 'https://www.kyowonedu.com/KEM/DGE/ETC/KEMInEP.jsp?no=' + this.userId + '&inpath=ADU'; 
      var copyText = '반가워요! 😊\n' +
                     '도구검사 신청하고 검사+상담까지 완료하면 \n' +
                     '너랑나랑 둘 다 커피 받아요! ☕ \n\n'+
                     '신청하러가기👇\n'+
                     url;

      // === 여기서부터는 네 원래 복사 로직 그대로 사용 ===
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(copyText)
          .then(function() {
            alert('추천 URL이 복사되었습니다.');
          })
          .catch(function() {
            alert('복사에 실패했습니다.');
          });
      } else {
        // 기존 fallback (textarea) 로직...
      }
    },
    goKss(){
      var that = this;
      var url = '/cpon/cponRcmdList';

      this.$api.dashboard
      .getSsoToken()
      .then(function (data) {
        if(data && data.token && data.userIdEnc){
          var ssoUrl = 'http://ksos.kyowon.co.kr?';
          ssoUrl += 'userId='+data.userIdEnc+'&token='+data.token+'&path='+url;
          that.$utils.nativeIf.outbound.outlink(ssoUrl)
        }else{
          // alert("SSO연동에 실패 하였습니다.")
          that.$utils.nativeIf.outbound.outlink("https://ksos.kyowon.co.kr"+url);
        }
      })
      .catch(function (error) {
          alert(error.rtMsg);
      });
    }
  },
  created: function() { 
  },
};
</script>
